import script from "./EditorJsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorJsEditor.vue?vue&type=script&setup=true&lang=js"

import "./EditorJsEditor.vue?vue&type=style&index=0&id=ea9e8382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea9e8382"]])

export default __exports__